import Vue from 'vue';
import {Input,Button,Container,Header,Aside,Main,Pagination,Menu,Submenu,MenuItemGroup,MenuItem,Card} from 'element-ui';
import {Form, FormItem ,Row,Col,Tag} from 'element-ui';
import {Table, TableColumn,Tooltip } from 'element-ui';
import{ Message,  Dropdown,DropdownMenu,DropdownItem, RadioGroup,Radio}  from 'element-ui';
import{ Loading,Dialog,Tabs,TabPane,Scrollbar}  from 'element-ui';
import{ MessageBox,Select,Option,DatePicker,Timeline,TimelineItem,Upload,Breadcrumb,BreadcrumbItem,Popconfirm,Popover}  from 'element-ui';


Vue.prototype.$message=Message
Vue.prototype.$confirm=MessageBox.confirm

Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(Pagination)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(Card)
Vue.use(Loading)
Vue.use(Row)
Vue.use(Col)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Upload)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Scrollbar)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Tag)
Vue.use(Tooltip)















